export default "__VITE_ASSET__ec406e4a__"